<div class="sidebar-wrapper pt-3">
  <div class="logo">
    <img class="assets-icon-home" src="assets/images/ey-logo.svg" />
  </div>
  <ul class="list-group list-group-flush py-3">
    <ng-container *ngFor='let sidebarSection of sidebarElementList'>
      <li
        routerLinkActive="active-route"
        class="list-group-item"
        [class.list-sub-menu]="sidebarSection.children"
        [ngClass]="{'active-link': actualRoute === '/workspaces'}"
        [routerLinkActiveOptions]="{ exact: sidebarSection.exact }"
      >
        <a class="list-item" [routerLink]="[sidebarSection.route]">
          <img class="icon" src="assets/images/{{sidebarSection.icon}}{{actualRoute === sidebarSection.route ? 'selected' : 'default'}}.svg" />
          <span class="title">{{sidebarSection.title}}</span>
        </a>
      </li>
      <ul class="list-group list-group-sub-menu pl-5 px-0" *ngIf='sidebarSection.children'>
        <li
          routerLinkActive='active-sub-route'
          class="list-group-item"
          *ngFor="let favouriteWorkspace of bookmarked"
        >
          <a class="list-item" routerLink="/workspaces/{{favouriteWorkspace.id}}">
            <span class="title-fav">{{favouriteWorkspace.name}}</span>
            <i class="ic-fav-on fav-icon"></i>
          </a>
        </li>
      </ul>
    </ng-container>
  </ul>
</div>
